import { isMonarchMultipleAccountsEnabled } from 'owa-account-source-list/lib/flights';
import { createLazyOrchestrator } from 'owa-bundling';
import { default as onSelectedAccountChanged } from 'owa-mail-account-store/lib/actions/onSelectedAccountChanged';
import { mutatorAction } from 'satcheljs';
import { getFilePickerStore } from '../store/filePickerStore';
import type FilePickerStore from '../store/schema/FilePickerStore';
import getDefaultFilePickerStore from '../utils/getDefaultFilePickerStore';

export const resetFilePickerStoreOrchestrator = createLazyOrchestrator(
    onSelectedAccountChanged,
    'clone_onSelectedAccountChanged',
    actionMessage => {
        if (!isMonarchMultipleAccountsEnabled()) {
            throw new Error(
                `Reset FileProvider store for account selection change is called when multi accounts is turned off. ${actionMessage.selectedEmailAddress}`
            );
        }

        // Reset the store to default values to remove any remnants of the old store
        resetStoreForAccountSelectionChange(getDefaultFilePickerStore());
    }
);

const resetStoreForAccountSelectionChange = mutatorAction(
    'resetStoreForAccountSelectionChange',
    (newStore: FilePickerStore) => {
        const store = getFilePickerStore();
        store.viewState = newStore.viewState;
    }
);
